import { render, staticRenderFns } from "./DocflowOutgoingForm.vue?vue&type=template&id=32c623d6&scoped=true&"
import script from "./DocflowOutgoingForm.vue?vue&type=script&lang=js&"
export * from "./DocflowOutgoingForm.vue?vue&type=script&lang=js&"
import style0 from "./DocflowOutgoingForm.vue?vue&type=style&index=0&id=32c623d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c623d6",
  null
  
)

export default component.exports